import PropTypes from 'prop-types';
import React, { Component } from 'react';
import isEmpty from 'lodash/isEmpty';
import forEach from 'lodash/forEach';
import currencyFormatter from 'currency-formatter';
import { PLCC_DYN_BANNER_EMPTY_CART_CODE } from 'yoda-checkout-components/lib/common/Constants';
import BannerPreShellLoader from 'yoda-checkout-components/lib/components/PreShellLoaders/BannerPreShellLoader/BannerPreShellLoader';

export class PLCCDynamicBannerMode extends Component {
    static defaultProps = {
        savings: '5',
        minSavings: '0',
        bannerHtml: '',
    };

    static propTypes = {
        savings: PropTypes.string,
        minSavings: PropTypes.string,
        bannerHtml: PropTypes.string,
        subTotal: PropTypes.string.isRequired,
        estSavings: PropTypes.string.isRequired,
        afterSavings: PropTypes.string.isRequired,
        handleDetailsClick: PropTypes.func.isRequired,
        handleCheckNowAnalytics: PropTypes.func.isRequired,
        bannerCode: PropTypes.string.isRequired,
        isPromoFinancing: PropTypes.bool.isRequired,
        deviceType: PropTypes.objectOf(PropTypes.object).isRequired,
        registerDetailsLinkAction: PropTypes.bool.isRequired,
    };

    componentDidMount() {
        this.handleComponentUpdate();
    }

    componentDidUpdate() {
        this.handleComponentUpdate();
    }

    /* istanbul ignore next */
    handleComponentUpdate = () => {
        const { subTotal, savings, minSavings, estSavings, afterSavings } = this.props;
        if (this.props.registerDetailsLinkAction) {
            const detailsButtons = document.querySelectorAll(
                '[data-plcc-id="at-link-plccBanner-id"]'
            );
            forEach(detailsButtons, (item) => {
                item.removeEventListener('click', this.handleDetailsClick);
                item.addEventListener('click', this.handleDetailsClick);
            });
        }

        const dynamicApplyButtons = document.querySelectorAll(
            '[data-plcc-id="plcc-dynamic-apply"], [data-plcc-id="plcc-dynamic-apply-savings"]'
        );
        forEach(dynamicApplyButtons, (item) => {
            item.removeEventListener('click', this.handleCheckNow);
            item.addEventListener('click', this.handleCheckNow);
        });

        /* istanbul ignore next */
        const subTotalElem = document.querySelectorAll('[data-plcc-id="subTotal-amt"]');
        const savingElem = document.querySelectorAll('[data-plcc-id="savings-percent"]');
        const minSavingElem = document.querySelectorAll('[data-plcc-id="min-savings-percent"]');
        const estSavingElem = document.querySelectorAll('[data-plcc-id="est-savings-amt"]');
        const afterSavingElem = document.querySelectorAll('[data-plcc-id="after-savings-amt"]');
        if (!isEmpty(subTotalElem)) {
            forEach(subTotalElem, (item) => {
                item.innerText = `${currencyFormatter.format(subTotal, { code: 'US' })}`; // eslint-disable-line no-param-reassign
            });
        }
        if (!isEmpty(savingElem)) {
            forEach(savingElem, (item) => {
                item.innerText = `${savings}`; // eslint-disable-line no-param-reassign
            });
        }
        if (!isEmpty(minSavingElem)) {
            forEach(minSavingElem, (item) => {
                item.innerText = `${minSavings}`; // eslint-disable-line no-param-reassign
            });
        }
        if (!isEmpty(estSavingElem)) {
            forEach(estSavingElem, (item) => {
                item.innerText = `${currencyFormatter.format(estSavings, { code: 'US' })}`; // eslint-disable-line no-param-reassign
            });
        }
        if (!isEmpty(afterSavingElem)) {
            forEach(afterSavingElem, (item) => {
                item.innerText = `${currencyFormatter.format(afterSavings, { code: 'US' })}`; // eslint-disable-line no-param-reassign
            });
        }
    };

    handleDetailsClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.props.handleDetailsClick(true);
    };

    handleCheckNow = (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.props.handleCheckNowAnalytics(e);
    };

    createMarkup = () => {
        return { __html: this.props.bannerHtml };
    };

    handleContentClick = (e) => {
        e.preventDefault();
        const { deviceType } = this.props;
        if (deviceType.isMobile) {
            this.props.handleDetailsClick(true);
        }
    };

    renderContent = () => <div dangerouslySetInnerHTML={this.createMarkup()} />;

    render() {
        const { bannerHtml, bannerCode, isPromoFinancing } = this.props;
        const showPreShellSecondeLine =
            bannerCode === PLCC_DYN_BANNER_EMPTY_CART_CODE || !isPromoFinancing;
        const showPreShellThirdLine = bannerCode === PLCC_DYN_BANNER_EMPTY_CART_CODE;
        return (
            <div data-automation-id="plcc-dyn-banner-mode">
                {!isEmpty(bannerHtml) ? (
                    this.renderContent()
                ) : (
                    <BannerPreShellLoader
                        showSecondeLine={showPreShellSecondeLine}
                        showThirdLine={showPreShellThirdLine}
                    />
                )}
            </div>
        );
    }
}

export default PLCCDynamicBannerMode;
